import React from 'react'

export default function NotFound() {
  return (
    <div>Sorry , Page not found</div>
  )
}
